import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-asbmccommerce',
    templateUrl: './asbmccommerce.component.html',
    styleUrls: ['./asbmccommerce.component.scss']
})
export class AsbmccommerceComponent implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }
}
